module.exports = __webpack_public_path__ + "static/media/400051_02.e2e1d52f.png";